<template>
    <div :class="[useMinmalYPadding ? 'py-3' : 'py-6', 'px-2']">
        <DetailedListItem
            v-if="isRegularResource"
            @deleteModel="deleteModel"
            :item="resource"
            :panelModalClass="resourceableModelClass"
            displayVariant="sidebar"
            :isToTheRight="isToTheRight"
            :showOptionsButton="true"
        />
        <div v-else-if="isRssFeed">
            <Link
                :href="resource.url"
                class="text-lg line-clamp-1 font-semibold font-header text-gray-900 underline-hover"
                v-text="resource.name"
            />
            <ResourceListItem
                :class="['py-1.5']"
                v-for="item in resource.feed"
                :key="item.id"
                :item="item"
                :design="design"
                :resourceableModelClass="resourceableModelClass"
                :isToTheRight="isToTheRight"
            />
        </div>
        <div v-else-if="isList" class="relative">
            <div
                :class="[
                    'absolute z-popover',
                    {
                        'right-0 bottom-0 3xl:bottom-auto 3xl:top-1/2 translate-y-1/3 3xl:-translate-y-1/2':
                            isToTheRight,
                        'right-0 top-0 -translate-y-1/4': !isToTheRight,
                    },
                ]"
                v-if="$isAdmin && options && options.length > 0"
            >
                <ButtonPopoverMenu :items="options">
                    <template #button="{ open }">
                        <div
                            :class="[
                                open
                                    ? `border-${resourceableModelClass}-accent bg-${resourceableModelClass}-accent text-${resourceableModelClass}`
                                    : 'border-transparent',
                                `border hover:border-${resourceableModelClass}-accent size-10 p-2 rounded-full transition duration-button-hover focus-style`,
                            ]"
                        >
                            <PhDotsThreeOutline
                                class="flex-grow"
                                weight="fill"
                            />
                        </div>
                    </template>
                </ButtonPopoverMenu>
            </div>
            <Link
                v-if="!hideListTitle"
                :href="resource.url"
                class="text-lg line-clamp-1 font-semibold font-header text-gray-900 underline-hover"
                v-text="resource.name"
            />
            <component
                :is="listParent"
                :class="[
                    {
                        'list-disc list-outside ml-6 font-bold':
                            listParent == 'ul',
                    },
                    {
                        'list-decimal list-outside ml-6 font-bold':
                            listParent == 'ol',
                    },
                ]"
            >
                <ResourceListItem
                    :class="[listParent == 'div' ? 'py-3' : 'py-1.5']"
                    v-for="item in resource.list_items"
                    :key="item.id"
                    :resourceableModelClass="resourceableModelClass"
                    :item="item"
                    :design="design"
                    :isToTheRight="isToTheRight"
                />
            </component>
        </div>
        <div v-else-if="false && isDynamicList">
            Placeholder: dynamisk lista
        </div>
        <ConfirmDeleteBaseModelModal
            v-if="$isAdmin"
            ref="confirmDeleteModal"
            :modelClass="resource.modelClass"
            :modelId="resource.id"
        />
    </div>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import ResourceListItem from '@/Components/Panels/ResourcePanel/ResourceListItem.vue'
import DetailedListItem from '@/Components/Panels/DetailedListItem.vue'
import { Link } from '@inertiajs/vue3'
import ButtonPopoverMenu from '@/Components/Utilities/ButtonPopoverMenu.vue'
import { PhDotsThreeOutline } from '@phosphor-icons/vue'
import ConfirmDeleteBaseModelModal from '@/Components/Modals/ConfirmDeleteBaseModelModal.vue'

export default {
    name: 'ResourcePanelItem',

    components: {
        ModelImage,
        ResourceListItem,
        DetailedListItem,
        Link,
        ButtonPopoverMenu,
        ConfirmDeleteBaseModelModal,
        PhDotsThreeOutline,
    },

    props: {
        title: {
            type: String,
            default: 'Related resources',
        },
        resource: {
            type: Object,
            default: () => {
                return {
                    image: null,
                    name: null,
                    created_at: null,
                    type: null,
                    type_id: null,
                    data: {},
                }
            },
        },
        // The modelClass where the panel is displayed
        resourceableModelClass: {
            type: String,
            required: true,
        },
        hideListTitle: {
            type: Boolean,
            default: false,
        },
        isToTheRight: {
            type: Boolean,
            default: false,
        },
    },

    created() {
        if (this.$isAdmin) {
            this.options = [
                {
                    text: this.$lang.get('Edit'),
                    href: this.$localizedRoute(
                        `${this.resource.modelClass}.edit`,
                        this.resource.id
                    ),
                    type: 'link',
                },
                {
                    text: this.$lang.get('Delete'),
                    type: 'button',
                    action: () => {
                        this.deleteModel()
                    },
                },
            ]
        }
    },

    computed: {
        isList() {
            return this.resource.type_id === 'list'
        },

        isDynamicList() {
            return this.resource.type_id === 'dynamic_list'
        },

        isRssFeed() {
            return this.resource.type_id === 'feed'
        },

        isRegularResource() {
            return !(this.isList || this.isDynamicList || this.isRssFeed)
        },

        useMinmalYPadding() {
            return this.isList || this.isRssFeed
        },

        design() {
            if (this.isRegularResource) {
                return null
            }

            return this.resource?.data?.design || 'detailed'
        },

        listParent() {
            switch (this.design) {
                case 'detailed':
                    return 'div'
                case 'numbered':
                    return 'ol'
                case 'bulleted':
                    return 'ul'
            }
        },
    },

    methods: {
        deleteModel() {
            this.$refs.confirmDeleteModal.confirmDelete()
        },
    },
}
</script>
